// Substitui "next/image" no bundle standalone do WordPress: sem otimização
// automática (o WP serve os arquivos estáticos direto), suporta os mesmos
// props usados no site (src, alt, width, height, fill, priority, sizes).
import type { ImgHTMLAttributes } from "react";

type ImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> & {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  fill?: boolean;
  priority?: boolean;
  sizes?: string;
};

export default function Image({ src, alt, fill, priority, sizes, className, width, height, ...rest }: ImageProps) {
  const isWhiteLogo = src.endsWith("/brand/sat-labs-logo-white.png");
  const logoBase = isWhiteLogo ? src.replace(/\.png$/, "") : "";
  const responsiveProps = isWhiteLogo
    ? {
        srcSet: `${logoBase}-128.webp 128w, ${logoBase}-192.webp 192w, ${src} 600w`,
        sizes: sizes ?? "96px",
      }
    : { sizes };

  if (fill) {
    return (
      // eslint-disable-next-line @next/next/no-img-element -- fora do Next.js aqui, <img> é o correto.
      <img
        src={src}
        alt={alt}
        {...responsiveProps}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
        className={`absolute inset-0 h-full w-full ${className ?? ""}`}
        {...rest}
      />
    );
  }
  return (
    // eslint-disable-next-line @next/next/no-img-element -- fora do Next.js aqui, <img> é o correto.
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      {...responsiveProps}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      className={className}
      {...rest}
    />
  );
}
